"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageT = exports.Message = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const payload_js_1 = require("../../solarxr-protocol/pub-sub/payload.js");
const topic_js_1 = require("../../solarxr-protocol/pub-sub/topic.js");
/**
 * Data that is sent from publishers to subscribers
 */
class Message {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsMessage(bb, obj) {
        return (obj || new Message()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsMessage(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new Message()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    topicType() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : topic_js_1.Topic.NONE;
    }
    topic(obj) {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.__union(obj, this.bb_pos + offset) : null;
    }
    payloadType() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : payload_js_1.Payload.NONE;
    }
    payload(obj) {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? this.bb.__union(obj, this.bb_pos + offset) : null;
    }
    static startMessage(builder) {
        builder.startObject(4);
    }
    static addTopicType(builder, topicType) {
        builder.addFieldInt8(0, topicType, topic_js_1.Topic.NONE);
    }
    static addTopic(builder, topicOffset) {
        builder.addFieldOffset(1, topicOffset, 0);
    }
    static addPayloadType(builder, payloadType) {
        builder.addFieldInt8(2, payloadType, payload_js_1.Payload.NONE);
    }
    static addPayload(builder, payloadOffset) {
        builder.addFieldOffset(3, payloadOffset, 0);
    }
    static endMessage(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createMessage(builder, topicType, topicOffset, payloadType, payloadOffset) {
        Message.startMessage(builder);
        Message.addTopicType(builder, topicType);
        Message.addTopic(builder, topicOffset);
        Message.addPayloadType(builder, payloadType);
        Message.addPayload(builder, payloadOffset);
        return Message.endMessage(builder);
    }
    unpack() {
        return new MessageT(this.topicType(), (() => {
            const temp = (0, topic_js_1.unionToTopic)(this.topicType(), this.topic.bind(this));
            if (temp === null) {
                return null;
            }
            return temp.unpack();
        })(), this.payloadType(), (() => {
            const temp = (0, payload_js_1.unionToPayload)(this.payloadType(), this.payload.bind(this));
            if (temp === null) {
                return null;
            }
            return temp.unpack();
        })());
    }
    unpackTo(_o) {
        _o.topicType = this.topicType();
        _o.topic = (() => {
            const temp = (0, topic_js_1.unionToTopic)(this.topicType(), this.topic.bind(this));
            if (temp === null) {
                return null;
            }
            return temp.unpack();
        })();
        _o.payloadType = this.payloadType();
        _o.payload = (() => {
            const temp = (0, payload_js_1.unionToPayload)(this.payloadType(), this.payload.bind(this));
            if (temp === null) {
                return null;
            }
            return temp.unpack();
        })();
    }
}
exports.Message = Message;
class MessageT {
    constructor(topicType = topic_js_1.Topic.NONE, topic = null, payloadType = payload_js_1.Payload.NONE, payload = null) {
        this.topicType = topicType;
        this.topic = topic;
        this.payloadType = payloadType;
        this.payload = payload;
    }
    pack(builder) {
        const topic = builder.createObjectOffset(this.topic);
        const payload = builder.createObjectOffset(this.payload);
        return Message.createMessage(builder, this.topicType, topic, this.payloadType, payload);
    }
}
exports.MessageT = MessageT;
